// Internal
import BRAND_DOMAINS from 'constants/brandDomains';

/**
 * Resolves the brand for a portal hostname.
 *
 * The host must either equal a known portal domain or be a sub-domain of one,
 * which lets `www.` and staging prefixes through while still rejecting
 * look-alikes such as `portal.lawnswood.com.au.example.com`.
 *
 * @param {string} hostname - Typically `window.location.hostname`
 * @returns {string} The brand name, or an empty string when unbranded
 */
export default function resolveBrandFromHostname(hostname) {
    // Hostnames are case insensitive and may carry a fully qualified trailing dot
    const host = String(hostname ?? '').toLowerCase().replace(/\.$/, '');

    if (!host) {
        return '';
    }

    const match = BRAND_DOMAINS.find(({ domain }) => host === domain || host.endsWith(`.${domain}`));

    return match ? match.brand : '';
}
